import { Link } from 'react-router-dom';

export default function ServicesHero() {
  return (
    <section className="relative pt-20 min-h-[440px] md:min-h-[500px] flex items-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=colorful%20variety%20of%20health%20supplement%20products%20capsules%20tablets%20powder%20drinks%20arranged%20on%20clean%20white%20surface%2C%20vibrant%20health%20food%20products%20display%2C%20professional%20commercial%20photography%2C%20fresh%20natural%20ingredients%20visible&width=1920&height=500&seq=services-hero-bg-01&orientation=landscape"
          alt="代工服務背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1a3a1a]/90 via-[#1a3a1a]/65 to-[#1a3a1a]/20" />
      </div>
      <div className="relative z-10 w-full max-w-screen-xl mx-auto px-6 lg:px-10 pb-16 pt-28">
        <div className="max-w-2xl">
          <span className="inline-block bg-[#4CAF50]/25 border border-[#4CAF50]/50 text-green-300 text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-5 tracking-wide">
            代工服務
          </span>
          <h1 className="text-white font-bold leading-tight mb-5">
            <span className="block">多元代工服務，</span>
            <span className="block text-green-300">一站式幫您搞定!</span>
          </h1>
          <p className="text-gray-200 text-[1.0625rem] leading-[1.75] max-w-xl mb-8">
            康永生技提供從配方劑型到成品包裝風格的完整代工服務 ，滿足您品牌的各類產品需求
          </p>
          <div className="flex flex-wrap gap-4">
            <Link to="/contact/form" className="whitespace-nowrap bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[1rem] px-7 py-3.5 rounded-full transition-all duration-300 cursor-pointer">
              立即諮詢
            </Link>
            <Link to="/partnership" className="whitespace-nowrap bg-white/15 hover:bg-white/25 border border-white/60 text-white font-semibold text-[1rem] px-7 py-3.5 rounded-full transition-all duration-300 cursor-pointer">
              了解合作流程
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}